<template>
  <div class="languages-modal">
    <v-dialog
      v-model="isVisible"
      max-width="780"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="languages-modal__title headline"
          primary-title
        >
          LANGUAGE
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="languages-modal__row mb-0">
            <v-col class="languages-modal__col col-4">
              <v-select
                v-model="newLanguage.name"
                class="form-field"
                :items="featuresData.language_name"
                dense
                item-color="blue"
                label="Language"
                placeholder="Choose language"
              />
            </v-col>
            <v-col class="languages-modal__col col-4">
              <v-select
                v-model="newLanguage.level"
                class="form-field"
                :items="featuresData.language_level"
                dense
                item-color="blue"
                label="Level"
                placeholder="Choose level"
              />
            </v-col>
            <v-col class="languages-modal__col col-4 text-left">
              <v-btn
                class="languages-modal__btn"
                outlined
                fab
                tile
                color="blue"
                @click="addLanguage"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <div class="languages-modal__languages-list">
            <h3 class="languages-modal__subtitle">
              List of languages
            </h3>
            <div class="languages-modal__chips">
              <v-chip
                v-for="(language, index) in languagesList"
                :key="index"
                class="mr-2 mb-2"
                label
                close
                close-icon="mdi-close"
                color="orange"
                dark
                @click:close="removeLanguage(index)"
              >
                {{ language.name }} {{ language.level }}
              </v-chip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="languages-modal__actions">
          <v-btn
            color="blue"
            dark
            large
            depressed
            :loading="processing"
            :min-width="256"
            @click="submit"
          >
            {{ submitName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },

    languagesData: {
      type: Array,
      required: false,
      default: () => [],
    },

    featuresData: {
      type: Object,
      required: true,
    },

    submitName: {
      type: String,
      required: false,
      default: 'Save',
    },
  },

  data() {
    return {
      newFeature: '',
      languagesList: [],
      newLanguage: {
        name: '',
        level: '',
      },
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.languagesList = this.isVisible ? [...this.languagesData] : [];
      this.newLanguage = {};
      this.clearLanguageInputs();
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
    },

    addLanguage() {
      if (this.newLanguage.name !== '' && this.newLanguage.level !== '') {
        this.languagesList.push(this.newLanguage);
        this.clearLanguageInputs();
      }
    },

    removeLanguage(index) {
      this.languagesList.splice(index, 1);
    },

    clearLanguageInputs() {
      this.newLanguage = {
        name: '',
        level: '',
      };
    },

    submit() {
      this.$emit('submit', this.languagesList);
    },
  },
};
</script>

<style lang="scss" scoped>
.languages-modal {
  &__title {
    display: flex;
    color: $main--headers;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__row {
    margin-right: -8px;
    margin-left: -8px;
  }

  &__col {
    padding: 0 8px 12px;
  }

  &__btn {
    border-radius: 4px;
    border-color: $color--secondary;
    width: 54px;
    height: 54px;
  }

  &__subtitle {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  &__input {
    max-width: 220px;
  }
}
</style>
